import React from 'react';
//import Portal from 'react-portal';
import _ from 'lodash';
//import Popover from '../Popover';
import { getListOfLocales, Locale, getCurrentLocal } from '../i18n/I18n';
import './I18nPopover.css';
import Storage from '../protocol/Storage';

export default class I18nPopover extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fullName: undefined,
      modal: '',
      showPopover: false,
      localsList: getListOfLocales(),
      selectedLocal: getCurrentLocal()
    };
  }

  componentDidMount() {}

  show = () => {
    this.setState({ showPopover: true });
  };

  hide = () => {
    this.setState({ showPopover: false });
  };

  onClickOptions = (local: Locale) => {
    Storage.set('LANG', local.key);
    location.reload();
  };

  renderListOfI18n = (item, i) => {
    return (
      <div
        onClick={() => this.onClickOptions(item)}
        key={i}
        className="localizationList"
        style={this.state.selectedLocal.key === item.key ? { color: 'var(--primary-style-color)' } : {}}>
        {item.name}
      </div>
    );
  };

  render() {
    return (
      <div name="I18nPopover">
        <div style={{ display: 'flex' }}>{this.state.localsList.map((item, i) => this.renderListOfI18n(item, i))}</div>
      </div>
    );
  }
}
